export const spacings = {
  xxs: 2,
  xs: 4,
  xs2: 6,
  sm: 8,
  sm2: 10,
  md: 16,
  lg: 24,
  lg2: 28,
  lg3: 30,
  xl: 32,
  xl1: 34,
  xl2: 36,
  xxl: 40,
  xxl2: 44,
  xxxl: 48,
  '4xl': 56,
  '5xl': 60,
  '6xl': 76,
  '8xl': 96,
  '10xl': 106,
};

export const formSpacings = {
  betweenInputs: 'lg' as SpacingOrNil,
};
